import {
    GET_ADVANCE_COMMENTS, GET_ADVANCE_COMMENTS_ERROR, INSERT_ADVANCE_COMMENT,
    INSERT_ADVANCE_COMMENT_ERROR, GET_DOCUMNETS_COMMENTS_FOR_AP_TEAM, GET_DOCUMNETS_COMMENTS_FOR_AP_TEAM_ERROR,
} from '../type'
import axios from 'axios';
import env from '../../ENV';
// import swal from '@sweetalert/with-react';
let ROOT_URL = env.BACKEND_URL;

export const GetAllAdvanceComments = (InvoiceId) => async dispatch => {
    console.log(InvoiceId, "%%%%")
    try {
        const res = await axios({
            method: 'get',
            url: `${ROOT_URL}advance-comment/all/${InvoiceId}`,
        })
        console.log(res, "Response")
        dispatch({
            type: GET_ADVANCE_COMMENTS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_ADVANCE_COMMENTS_ERROR,
            payload: console.log(e),
        })
    }

}

export const InsertAdvanceComment = (input) => async dispatch => {
    console.log("recieved in store ", input)
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}advance-comment/add`,
            data: input,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: INSERT_ADVANCE_COMMENT,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: INSERT_ADVANCE_COMMENT_ERROR,
            payload: console.log(e),
        })
    }

}
export const GetInvoiceDetailsForAPteamApproval = (InvoiceId) => async dispatch => {
    // console.log(InvoiceId, "%%%%")
    try {
        const res = await axios({
            method: 'get',
            url: `${ROOT_URL}${InvoiceId}/document-comment-merge-view-for-ap-team/all`,
        })
        console.log(res, "Response")
        dispatch({
            type: GET_DOCUMNETS_COMMENTS_FOR_AP_TEAM,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_DOCUMNETS_COMMENTS_FOR_AP_TEAM_ERROR,
            payload: console.log(e),
        })
    }

}